module.exports = __webpack_public_path__ + "static/graph-year-1-36585f522d91d3d7ba0ed10fa608b525.svg";